import { useState, useCallback } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import Button from '../../../core-components/theme/components/Button/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import AddLogbookTemplateModal from './AddLogbookTemplateModal';
import { useQueryClient } from '@tanstack/react-query';
import { fetchLogbookOptions } from '../api/logbookApi';
import { createPrefetchHandler } from '../../../utilities/prefetchHandler';
import { DATA_INPUT_RULES, anyPlant, useCan } from '../../../access';

export default function AddLogbookTemplateButtonAndModal() {
    const { t } = useTranslation();
    const [openEditLogbookTemplateBox, setOpenEditLogbookTemplateBox] = useState(false);
    const queryClient = useQueryClient()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const canCreate = useCan(DATA_INPUT_RULES.createLogbookTemplate, anyPlant);

    const prefetchLogbookOptions = createPrefetchHandler(queryClient, {
        queryKey: ['logbookOptions'],
        queryFn: fetchLogbookOptions,
        staleTime: 60000,
    });

    const handleOpen = useCallback(() => {
        setOpenEditLogbookTemplateBox(true);
    }, []);

    const handleClose = useCallback(() => {
        setOpenEditLogbookTemplateBox(false);
    }, []);

    if (!canCreate) return null;

    return (
        <>
            <Button
                onClick={handleOpen}
                onMouseEnter={prefetchLogbookOptions}
                variant="contained"
                aria-label={t('logbook.templates.addTemplate', 'Add Template')}
            >
                <AddIcon />
                {!isMobile && t('logbook.templates.addTemplate', 'Add Template')}
            </Button>

            {openEditLogbookTemplateBox && (
                <AddLogbookTemplateModal open={openEditLogbookTemplateBox} onClose={handleClose} />
            )}
        </>
    );
}
